import { render, staticRenderFns } from "./GridLinkedin.vue?vue&type=template&id=c794946c&"
import script from "./GridLinkedin.vue?vue&type=script&lang=js&"
export * from "./GridLinkedin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports